import { OnlineContractingStateEnum } from 'v3/data/store/onlineContracting/enums';

export const OnlineContractingStatusMap = {
  [OnlineContractingStateEnum.ContractingStarted]: 'Contratação iniciada',
  [OnlineContractingStateEnum.ContractingDenied]: 'Contratação negada',
  [OnlineContractingStateEnum.ProcessingCreditAnalysis]: 'Processando análise de crédito',
  [OnlineContractingStateEnum.CreditAnalysisRejected]: 'Análise de crédito reprovada',
  [OnlineContractingStateEnum.WaitingProposalGeneration]: 'Aguardando geração de proposta',
  [OnlineContractingStateEnum.WaitingSelfie]: 'Aguardando selfie',
  [OnlineContractingStateEnum.CpfBlocked]: 'CPF bloqueado',
  [OnlineContractingStateEnum.WaitingProposalAcceptance]: 'Aguardando aceite de proposta',
  [OnlineContractingStateEnum.ContractingFinished]: 'Contratação finalizada',
  [OnlineContractingStateEnum.WaitingDownPayment]: 'Aguardando pagamento da entrada',
  [OnlineContractingStateEnum.WaitingBilling]: 'Aguardando faturamento',
  [OnlineContractingStateEnum.ProcessingBilling]: 'Processando faturamento',
  [OnlineContractingStateEnum.ProcessingCancellation]: 'Processando cancelamento',
  [OnlineContractingStateEnum.ExpiredKey]: 'Chave expirada',
};

export const getContractingStatusEnum = (title: string): OnlineContractingStateEnum | undefined => {
  return Object.keys(OnlineContractingStatusMap).find(
    (key) => OnlineContractingStatusMap[key as keyof typeof OnlineContractingStatusMap] === title,
  ) as OnlineContractingStateEnum | undefined;
};
